const getApiUrl = () => {
  if (window.location.hostname === 'admin.zebel.io') {
    return 'https://api.zebel.io/v1';
  }

  if (window.location.hostname === 'admin.amazon.zebel.io') {
    return 'https://api.amazon.zebel.io/v1';
  }

  return 'http://localhost:5001/v1';
};

const getCookieDomain = () => {
  if (window.location.origin.includes('localhost')) return 'localhost';
  if (window.location.origin.includes('admin.zebel.io')) return '.admin.zebel.io';
  if (window.location.origin.includes('admin.amazon.zebel.io')) return '.admin.amazon.zebel.io';
};

const formatApiError = (err) => {
  let errMessage = 'Something went wrong.';
  if (err.response?.data?.message) {
    errMessage = err.response.data.message;
  } else if (err.message) {
    errMessage = err.message;
  }
  return errMessage;
};

const formatAndThrowApiError = (err) => {
  throw Error(formatApiError(err));
};

export { getCookieDomain, getApiUrl, formatApiError, formatAndThrowApiError };
